import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import PopupMask from '@/componentsUI/PopupMask';
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import React, { ReactNode } from 'react'
import './index.less'
import ButtonUI from '@/componentsUI/Button';

import backgroundImage from '../../../../../pages/redpackRain/assets/guanxiao0.png' //'../assets/guanxiao0.png'
import rotateImage from '../../../../../pages/redpackRain/assets/guanxiao2.png'
import startImage from '../../../../../pages/redpackRain/assets/guanxiao1.png'
export interface WheelAwardPopupProps {
    text?: string
    icon?: ReactNode
 }

const WheelAwardPopup = NiceModal.create((props:WheelAwardPopupProps) => {
    const {t} = useTranslationPlus()
    const { text , icon} = props;
    const { visible, remove } = useModal();
    function onClick(){
      remove()
    }
  
    return (
      <PopupMask visible={visible}>
        <div className='WheelAwardPopup'>
          <div className='backgroundImage'>
             <img src={backgroundImage} draggable={false}/>
          </div>
          <div className='rotateImage'>
            <img src={rotateImage} draggable={false}/>
          </div>
          <div className='backgroundImage-1'>
             <img src={startImage} draggable={false}/>
          </div>
          <div className='title'>
             <span>{t('redpack.Reward')}</span>
          </div>
          <div className='award-icon'>
             {icon}
          </div>
          <div className='bottom-button'>
             <ButtonUI type={'primary'} onClick={onClick}>{t('redpack.collect')}</ButtonUI>
          </div>
          <div className='amount-text'>
              <span>{text}</span>
          </div>
        </div>
      </PopupMask>
    )
  })
  
  
  export default WheelAwardPopup